import React, { useState } from 'react';
import AddCohortPage from '../add-cohort/page';
import ScheduledCohortsPage from '../scheduled-cohorts/page';

const TABS = [
  { key: 'cohorts', label: 'Cohorts' },
  { key: 'scheduled', label: 'Scheduled Cohorts' },
];

export default function CohortsModule() {
  const [activeTab, setActiveTab] = useState('cohorts');

  return (
    <div>
      {/* Tab bar */}
      <div
        style={{
          display: 'flex',
          gap: 32,
          borderBottom: '1px solid #E5E7EB',
          marginBottom: 24,
        }}
      >
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? '#4F46E5' : '#6B7280',
                background: 'none',
                border: 'none',
                borderBottom: isActive ? '2px solid #4F46E5' : '2px solid transparent',
                padding: '10px 0',
                cursor: 'pointer',
                transition: 'color 150ms ease, border-color 150ms ease',
                whiteSpace: 'nowrap',
                fontFamily: "'Gellix', 'Inter', sans-serif",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      {activeTab === 'cohorts' && <AddCohortPage />}
      {activeTab === 'scheduled' && <ScheduledCohortsPage />}
    </div>
  );
}
